import { T } from "./theme";

export default function AdminStatus({ active, t }) {
  return <strong style={{ color: active ? "#15803D" : T.red }}>{active ? t("admin.active") : t("admin.inactive")}</strong>;
}
